export type SessionBrowserId = 'chrome' | 'firefox' | 'safari' | 'edge' | 'opera' | 'unknown';
export type SessionOsId = 'windows' | 'macos' | 'ios' | 'android' | 'linux' | 'unknown';

const BROWSER_LABEL_FR: Record<SessionBrowserId, string> = {
  chrome: 'Chrome',
  firefox: 'Firefox',
  safari: 'Safari',
  edge: 'Edge',
  opera: 'Opera',
  unknown: 'Navigateur',
};

const OS_LABEL_FR: Record<SessionOsId, string> = {
  windows: 'Windows',
  macos: 'macOS',
  ios: 'iOS',
  android: 'Android',
  linux: 'Linux',
  unknown: 'Système',
};

export type SessionClientDisplay = {
  browser: SessionBrowserId | null;
  browserLabel: string | null;
  os: SessionOsId | null;
  osLabel: string | null;
};

export function parseSessionClientDisplay(userAgent: string | null | undefined): SessionClientDisplay {
  const ua = userAgent?.trim();
  if (!ua) {
    return { browser: null, browserLabel: null, os: null, osLabel: null };
  }
  const lower = ua.toLowerCase();

  let browser: SessionBrowserId | null = null;
  if (lower.includes('edg/')) browser = 'edge';
  else if (lower.includes('firefox/')) browser = 'firefox';
  else if (lower.includes('opr/') || lower.includes('opera')) browser = 'opera';
  else if (lower.includes('chrome/') || lower.includes('chromium')) browser = 'chrome';
  else if (lower.includes('safari/')) browser = 'safari';
  else if (/mozilla|applewebkit/i.test(ua)) browser = 'unknown';

  let os: SessionOsId | null = null;
  if (lower.includes('iphone') || lower.includes('ipad') || lower.includes('ios')) os = 'ios';
  else if (lower.includes('android')) os = 'android';
  else if (lower.includes('windows')) os = 'windows';
  else if (lower.includes('mac os') || lower.includes('macintosh')) os = 'macos';
  else if (lower.includes('linux') || lower.includes('cros')) os = 'linux';
  else if (browser) os = 'unknown';

  return {
    browser,
    browserLabel: browser ? BROWSER_LABEL_FR[browser] : null,
    os,
    osLabel: os ? OS_LABEL_FR[os] : null,
  };
}
